import { render, staticRenderFns } from "./DxTreePlanning.vue?vue&type=template&id=20ae72ca&scoped=true&"
import script from "./DxTreePlanning.vue?vue&type=script&lang=js&"
export * from "./DxTreePlanning.vue?vue&type=script&lang=js&"
import style0 from "./DxTreePlanning.vue?vue&type=style&index=0&id=20ae72ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae72ca",
  null
  
)

export default component.exports